// extracted by mini-css-extract-plugin
module.exports = {"campaignBanner":"CampaignBanner_campaignBanner__Wj1ED","mobile":"CampaignBanner_mobile__coXRi","desktop":"CampaignBanner_desktop__Ihkkl"};